import styled from 'styled-components'

const ServicesStyle = styled.div`
  min-height: 25vh;
  width: 90vw;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  overflow-y: auto;
  margin-top: 7vh;
  margin-bottom: 6.5vh;
  position: relative;
  justify-content: space-around;

  .scroll-section {
    min-height: 25vh;
    width: 90vw;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    overflow-y: auto;
    margin-top: 7vh;
    margin-bottom: 6.5vh;
    position: relative;
    justify-content: space-around;
  }

  .arrow {
    position: absolute;
    right: 0;
    bottom: 1rem;
    width: 1.5rem;
    transform: rotate(180deg);
    z-index: 8;
    animation: moveBackAndForth 2s linear infinite;
  }

  @keyframes moveBackAndForth {
    0% {
      right: 0;
    }
    50% {
      right: 7px;
    }
    100% {
      right: 0;
    }
  }

  @media (min-width: 768px) {
    .arrow {
      display: none;
    }
  }

  @media (max-width: 768px) {
    .scroll-section {
      justify-content: start;
      display: flex;
      scrollbar-y: none;
      scrollbar-x: hidden;
    }
  }
`

export default ServicesStyle
